"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _hubUsersActions = require("../actions/hubUsersActions");

var initialState = (0, _immutable.Map)();

function fromRaw(raw) {
  return new _immutable.Set(raw.scopeInfo.scopeName);
}

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _hubUsersActions.requestActionTypes.SUCCESS, function (state, action) {
  return (0, _mergeWithCollectionOfType.default)(fromRaw, action.payload.data.users, state);
}), initialState);

exports.default = _default;
module.exports = exports.default;